module.exports = __webpack_public_path__ + "static/vinos_poligono-5-e355f21b3749b323a0782ae5c4562dfc.jpg";